import { call } from 'redux-saga/effects';
import { callWithAuth } from '../../sagaApiHelper';
import { verifyMediaTemplateApi } from '../../../api/apiLists/verifyMediaTemplateApi';
import { getOrFetchWabaId } from './utils';

export function* performMediaVerification(mediaPayload = {}) {
  const payload = mediaPayload || {};

  if (!payload.source && !payload.fileBase64) {
    return { success: false, error: 'Missing file data or S3 source for verification' };
  }

  let wabaId = payload.wabaId || '';
  if (!wabaId) {
    wabaId = yield* getOrFetchWabaId();
  }

  const appId = payload.appId || process.env.REACT_APP_FACEBOOK_SDK_APP_ID || null;

  if (!wabaId || !appId) {
    return { success: false, error: 'Missing WABA ID or App ID for media verification' };
  }

  try {
    let verifyPayload;

    if (payload.source === 's3') {
      verifyPayload = {
        wabaId,
        appId,
        mimeType: payload.mimeType,
        source: payload.source,
        bucket: payload.bucket,
        key: payload.key
      };
    } else {
      verifyPayload = {
        wabaId,
        appId,
        fileName: payload.fileName,
        fileLength: payload.fileLength,
        mimeType: payload.mimeType,
        fileBase64: payload.fileBase64
      };
    }

    const res = yield call(callWithAuth, verifyMediaTemplateApi, verifyPayload);

    if (res?.status === true && res?.data?.header_handle) {
      return { success: true, headerHandle: res.data.header_handle, response: res };
    }

    const errorMsg = res?.errMsg || res?.data?.error || 'Failed to verify media';
    return { success: false, error: errorMsg, response: res };
  } catch (error) {
    return { success: false, error: error.message || 'Error occurred while verifying media' };
  }
}
